/** @format */

import { api } from 'utility';
import { getVerifyNewOwnerUrl } from 'URLs';
export function verifyNewOwner(params) {
  return api.get(getVerifyNewOwnerUrl(), { params }).then((res) => res.data);
}

export default {
  verifyNewOwner,
};
